module.exports = __webpack_public_path__ + "img/0-66.2fbdc04c.jpg";